'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutPropertiesLoose = require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var bumbag = require('bumbag');
var Layout_components_LoadingPage = require('./LoadingPage.js');
require('@fortawesome/pro-regular-svg-icons/faSpinnerThird');
require('@fortawesome/react-fontawesome');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _excluded = ["backLink", "backText", "disablePadding", "errorMessage", "children", "isMobile", "isLoading", "loadingTitle", "minWidthBreakpoint", "previewComponent"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var ContentBody = bumbag.styled(bumbag.Box)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  padding: 20px;\n  margin-bottom: 100px;\n  position: ", ";\n\n  @media screen and (max-width: 900px) {\n    margin-bottom: 300px;\n  }\n\n  & .bb-Card {\n    @media screen and (max-width: 900px) {\n      margin-left: -20px;\n      margin-right: -20px;\n    }\n  }\n\n  ", ";\n"])), function (props) {
  return (// @ts-expect-error TS(2339): Property 'isPreviewComponentActive' does not exist... Remove this comment to see the full error message
    props.isPreviewComponentActive ? 'relative' : 'initial'
  );
}, function (props) {
  return (// @ts-expect-error TS(2339): Property 'disablePadding' does not exist on type '... Remove this comment to see the full error message
    props.disablePadding && bumbag.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose__default["default"](["\n      padding: unset;\n\n      & .bb-Card {\n        @media screen and (max-width: 900px) {\n          margin-left: unset;\n          margin-right: unset;\n        }\n      }\n    "])))
  );
});
var Wrapper = bumbag.styled(bumbag.Container)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose__default["default"](["\n  ", ";\n\n  ", ";\n"])), function (_ref) {
  var previewComponent = _ref.previewComponent;
  return previewComponent ? 'filter: blur(5px);' : '';
}, function (props) {
  return (// @ts-expect-error TS(2339): Property 'disablePadding' does not exist on type '... Remove this comment to see the full error message
    props.disablePadding && bumbag.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose__default["default"](["\n      && {\n        padding: unset;\n      }\n    "])))
  );
});
var DarkContentOverlay = bumbag.styled(bumbag.Box)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose__default["default"](["\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.3);\n  z-index: 1;\n  width: 100%;\n  min-height: 3000px;\n  left: 0;\n  top: 0;\n"])));

function Content(props) {
  props.backLink;
      props.backText;
      var disablePadding = props.disablePadding,
      errorMessage = props.errorMessage,
      children = props.children;
      props.isMobile;
      var isLoading = props.isLoading,
      loadingTitle = props.loadingTitle,
      minWidthBreakpoint = props.minWidthBreakpoint,
      previewComponent = props.previewComponent,
      restProps = _objectWithoutPropertiesLoose__default["default"](props, _excluded);

  return (
    /*#__PURE__*/
    // @ts-expect-error TS(2322): Type '{ children: Element[]; disablePadding: boole... Remove this comment to see the full error message
    React__default["default"].createElement(ContentBody, _extends__default["default"]({
      disablePadding: disablePadding,
      isPreviewComponentActive: Boolean(previewComponent)
    }, restProps), previewComponent && /*#__PURE__*/React__default["default"].createElement(DarkContentOverlay, null), isLoading ? /*#__PURE__*/React__default["default"].createElement(Layout_components_LoadingPage["default"], {
      title: loadingTitle
    }) : /*#__PURE__*/React__default["default"].createElement(Wrapper, {
      breakpoint: minWidthBreakpoint // @ts-expect-error TS(2322): Type '{ children: any; breakpoint: string; disable... Remove this comment to see the full error message
      ,
      disablePadding: disablePadding,
      isFluid: !minWidthBreakpoint,
      previewComponent: Boolean(previewComponent)
    }, errorMessage ?
    /*#__PURE__*/
    // @ts-expect-error TS(2322): Type '"0"' is not assignable to type 'Flexible<Spa... Remove this comment to see the full error message
    React__default["default"].createElement(bumbag.Alert, {
      hasIcon: true,
      marginTop: "0",
      marginBottom: "major-2",
      type: "danger",
      variant: "tint"
    }, errorMessage) : children))
  );
}

Content.defaultProps = {
  backLink: undefined,
  backText: undefined,
  disablePadding: false,
  errorMessage: undefined,
  isLoading: false,
  loadingTitle: undefined,
  minWidthBreakpoint: undefined,
  previewComponent: undefined
};

exports["default"] = Content;
